/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Action/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import No from './No/index'
import React from 'react'
import Seat from './Seat/index'



/** @type {import('Simple/types.js').View} */
export default function Action({
  children,
  viewPath = "/App/Account/WaitingRoom/Content/Content/Waiting/Appointments/Content/Appointment/Action"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let selectedIsHoveredValueData = fromData.useDataFormat({ viewPath,
context: 'selected',
path: 'is_hovered',
format: fromHelpers.getView,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: selectedIsHoveredValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Seat'}>
<Seat
  viewPath={`${viewPath}/Seat`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}